// @flow
import * as React from 'react';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { Input, Menu, Button, Dropdown } from 'antd';
import { connect } from 'react-redux';
import { PERMISSIONS, createPermitFunction } from '../../../Evolve/Utilities/permissions';
import { isAdmin } from 'Common';

const styles = {

  stack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 25
  },

  heading: {
    flex: 1,
    margin: 0
  }
}

type Props = {
  searchTerm: string,
  userPermissions: [],
  onChangeSearch: Function,
  onSubmitSearch: Function,
  onClickNewValuation: Function,
  onClickExport: Function
}

class Header extends React.PureComponent<Props> {

  render () {
    const {
      searchTerm,
      userPermissions,
      onClickNewValuation,
      onSubmitSearch,
      onChangeSearch,
      onClickExport
    } = this.props;

    const permit = createPermitFunction(userPermissions);

    const exportMenu = (
      <Menu onClick={onClickExport}>
        <Menu.Item key="excel">Export to Excel</Menu.Item>
        <Menu.Item key="csv">Export to CSV</Menu.Item>
      </Menu>
    );

    return (
      <div class="_header_bar">

        <h1>
          Valuations
        </h1>

        <Input.Search
          value={searchTerm}
          onChange={onChangeSearch}
          onSearch={onSubmitSearch}
          placeholder="Search"
          enterButton
          style={{ width: 250 }}
        />

        {(isAdmin() && permit('exports')) && (

          <React.Fragment>

            <div style={{ width: 10 }} />

            <Dropdown overlay={exportMenu}>
              <Button>
                <CloudDownloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
              </Button>
            </Dropdown>

          </React.Fragment>

        )}

        <div style={{ width: 10 }} />

        <Button type="primary" onClick={onClickNewValuation}>
          New Valuation
        </Button>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(Header)
